import { TrackEventAPIRequest } from 'utils/constants/network';
import { callAPI } from 'utils/network';

class Tabbalytics {
  track(name, bookingID, userID, payload) {
    const apiRequest = TrackEventAPIRequest({
      name: name,
      booking: bookingID,
      user_id: userID,
      payload: payload,
    });

    return callAPI(apiRequest)
      .then(json => {})
      .catch(err => {});
  }
}

const instance = new Tabbalytics();
export default instance;



// WEBPACK FOOTER //
// ./src/utils/libraries/tabbalytics/index.js